const LOGGER_ENABLED = false;
const phoneticLogger = {
  // eslint-disable-next-line no-console
  prefix: 'N/A',
  info(...args: unknown[]) {
    if (LOGGER_ENABLED) {
      // eslint-disable-next-line no-console
      console.log(`${this?.prefix || ''}`, ...args);
    }
  },
  // eslint-disable-next-line no-console
  error(...args: unknown[]) {
    if (LOGGER_ENABLED) {
      // eslint-disable-next-line no-console
      console.error(`${this?.prefix || ''}`, ...args);
    }
  },
};
export default phoneticLogger;
